//протокол вертикальности (1,3,4 вкладка готовы)
import React, { useState, useEffect, useRef } from "react"; 
import axios from "axios";
import {
  CCard,
  CCardBody,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CButton,
  CFormInput,
  CFormSelect,
  CTable,
  CTableBody,
  CTableRow,
  CTableDataCell,
  CTableHeaderCell,
  CTableHead,
  CSpinner
} from "@coreui/react";

import PhotoParkingModal from './Tabs/PhotoParkingModal';
import PhotoTab from './Tabs/PhotoTab';
import SurveyInfoTab from './Tabs/SurveyInfoTab';
import AddResultModal from './Tabs/AddResultModal';
import AddMeasurementModal from './Tabs/AddMeasurementModal';
import BindingPointsModal from './Tabs/BindingPointsModal';

const ProtocolVerticality = ({ ldoc, nvalue, activeProtocolId, refreshProtocols }) => {
  // Состояния
  const [activeKey, setActiveKey] = useState(1);
  const [groupedData, setGroupedData] = useState({});
  const [normativeDocs, setNormativeDocs] = useState([]);
  const [goalMeasurementsOptions, setGoalMeasurementsOptions] = useState([]);
  const [directionsOptions, setDirectionsOptions] = useState([]);
  const [pointsHeightOptions, setPointsHeightOptions] = useState([]);
  const [measurementToolsOptions, setMeasurementToolsOptions] = useState([]);
  const [measurementConductedByOptions, setMeasurementConductedByOptions] = useState([]);
  const [developedByOptions, setDevelopedByOptions] = useState([]);
  const [addResultModalVisible, setAddResultModalVisible] = useState(false);
  const [addMeasurementModalVisible, setAddMeasurementModalVisible] = useState(false);
  const [newProtocolId, setNewProtocolId] = useState(null);
  const [photoTabProtocolId, setPhotoTabProtocolId] = useState(null);
  const [protocolId, setProtocolId] = useState(null);

  const [peopleList, setPeopleList] = useState([]);
  const [toolsList, setToolsList] = useState([]);
  const [normativeDocsList, setNormativeDocsList] = useState([]);

  const [onSaveProtocol, setOnSaveProtocol] = useState(null);

  // Выбранные значения
  const [selectedGoal, setSelectedGoal] = useState("");
  const [selectedNormativeDoc, setSelectedNormativeDoc] = useState('');
  const [selectedDirection, setSelectedDirection] = useState('');
  const [selectedPointsHeight, setSelectedPointsHeight] = useState('');
  const [selectedMeasurementTool, setSelectedMeasurementTool] = useState('');
  const [selectedConductedBy, setSelectedConductedBy] = useState('');
  const [selectedDevelopedBy, setSelectedDevelopedBy] = useState('');
  const [baseWidthInput, setBaseWidthInput] = useState("");
  const [axisRotateInput, setAxisRotateInput] = useState("Нет");

  // Даты
  const [dateMeasurement, setDateMeasurement] = useState("");
  const [dateProtocol, setDateProtocol] = useState("");

  // Фото
  const [isModalVisible, setModalVisible] = useState(false);
  const [modalName, setModalName] = useState('');
  const [modalFilePath, setModalFilePath] = useState('');
  const [photoItems, setPhotoItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);

  // Список станций
  const [stationsList, setStationsList] = useState([]);
  const [selectedStationId, setSelectedStationId] = useState(null);

  // Перевязка стоянок
  const [bindingPointsModalVisible, setBindingPointsModalVisible] = useState(false);
  const [selectedStationsForBinding, setSelectedStationsForBinding] = useState([]);

  // Токен
  const token = localStorage.getItem("token");

  const getIdByName = (name, list) => {
    const item = list.find((item) => item.name === name);
    return item ? item.Id : null;
  };

  const loadStations = () => {
    if (!newProtocolId) return;

    axios.get(`/api/protocols/station/?idProtocol=${newProtocolId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(response => {
        const stations = response.data || [];
        setStationsList(stations);
      })
      .catch(error => {
        console.error("Ошибка при загрузке станций:", error);
      });
  };

  const handleDeleteStation = () => {
    if (!selectedStationId) {
      alert("Выберите станцию для удаления");
      return;
    }
    if (!window.confirm("Вы уверены, что хотите удалить эту станцию и все связанные данные?")) {
      return;
    }

    // Удаляем станцию и все её source-записи
    axios.delete(`/api/protocols/station/?id=${selectedStationId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        alert("Станция и связанные записи успешно удалены");
        setSelectedStationId(null); // Сбрасываем выбор
        loadStations(); // Обновляем список станций
      })
      .catch(error => {
        console.error("Ошибка при удалении станции:", error);
        alert("Не удалось удалить станцию");
      });
  };

  const handleUnbindPoint = () => {
    if (!selectedStationId) {
      alert("Выберите станцию для удаления точки перевязки");
      return;
    }

    const station = stationsList.find(s => s.Id === selectedStationId);

    if (!station) {
      alert("Не удалось найти данные по выбранной станции");
      return;
    }

    console.log("Данные станции для удаления перевязки:", station);

    const { DressPoint, idParent, IsRotate } = station;

    if (!DressPoint && !idParent && !IsRotate) {
      alert("Для этой стоянки точка перевязки не назначена.");
      return;
    }

    const confirmed = window.confirm("Вы уверены, что хотите удалить точку перевязки для выбранной стоянки?");
    if (!confirmed) return;

    const payload = {
      Id: station.Id,
      DressPoint: 0,
      idParent: 0,
      IsRotate: 0,
    };

    axios.put("/api/protocols/station/", payload, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        alert("Точка перевязки успешно удалена");
        loadStations(); // Перезагрузим список после обновления
      })
      .catch((error) => {
        console.error("Ошибка при удалении точки перевязки:", error);
        alert("Не удалось удалить точку перевязки");
      });
  };


  const sendTableDataToServer = (idStation, tableData) => {
    axios.post('/api/protocols/source/', {
      idStation,
      measurements: tableData.map(row => ({
        PointNum: row.id,
        PointMark: row.mark,
        KrGrad: row.kr_deg_measured,
        KrMin: row.kr_min_measured,
        KrSec: row.kr_sec_measured,
        KlGrad: row.kl_deg_measured,
        KlMin: row.kl_min_measured,
        KlSec: row.kl_sec_measured,
        SubStation: false // или true, если это подстанция
      }))
    }, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(response => {
        console.log('Данные таблицы успешно сохранены:', response.data);
      })
      .catch(error => {
        console.error('Ошибка при сохранении данных таблицы:', error);
      });
  };
  // При открытии модального окна
  const openAddMeasurementModal = () => {
    console.log("Открываем модальное окно, newProtocolId:", newProtocolId);
    if (newProtocolId === null) {
      console.warn("Предупреждение: newProtocolId равен null");
    }
    setAddMeasurementModalVisible(true);
  };

  function handleSelectOrAddToList(list, value, setList, setSelected) {
    if (!list || !Array.isArray(list)) return;

    const index = list.indexOf(value);

    if (index === -1) {
      const updatedList = [...list, value];
      setList(updatedList); // Обновляем список
      setSelected(value);   // Устанавливаем новое значение как выбранное
    } else {
      setSelected(value);   // Уже есть в списке — просто выбираем
    }
  }

  function formatDate(originalDate) {
    const [day, month, year] = originalDate.split('.');
    // Используем padStart для корректного формата двузначного месяца и дня
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  useEffect(() => {
    if (ldoc !== null && nvalue !== null) {
      axios
        .get(`/api/ldoc/${ldoc}/protocol-info/${nvalue}/`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const result = response.data.data || [];

          const grouped = {};
          const normativeList = [];
          const goalList = [];
          const directionsList = [];
          const pointsHeightList = [];
          const measurementToolsList = [];
          const measurementConductedByList = [];
          const developedByList = [];

          // Храним объекты с Id
          const peopleListTemp = [];
          const toolsListTemp = [];
          const normativeDocsListTemp = [];

          result.forEach((item) => {
            const key = item[""]?.trim();
            const value = item.ObjName;
            if (!key) return;

            switch (key) {
              case "Нормативные документы":
                normativeList.push(value);
                normativeDocsListTemp.push({ Id: item.Id, name: value });
                break;

              case "Цель измерений":
                goalList.push(value);
                break;

              case "Расположение направлений стоянок":
                directionsList.push(value);
                break;

              case "Расположение точек съемки по высоте опоры":
                pointsHeightList.push(value);
                break;

              case "Средства измерений":
                if (value) {
                  measurementToolsList.push(value);
                  toolsListTemp.push({ Id: item.Id, name: value });
                }
                break;

              case "Измерения проводил":
                measurementConductedByList.push(value);
                peopleListTemp.push({ Id: item.Id, name: value });
                break;

              case "Разработал":
                developedByList.push(value);
                break;

              default:
                grouped[key] = value;
            }
          });

          // Сохраняем списки с Id
          setPeopleList(peopleListTemp);
          setToolsList(toolsListTemp);
          setNormativeDocsList(normativeDocsListTemp);

          // Остальные состояния
          setGroupedData(grouped);
          setNormativeDocs(normativeList);
          setGoalMeasurementsOptions(goalList);
          setDirectionsOptions(directionsList);
          setPointsHeightOptions(pointsHeightList);
          setMeasurementToolsOptions(measurementToolsList);
          setMeasurementConductedByOptions(measurementConductedByList);
          setDevelopedByOptions(developedByList);

          setSelectedGoal(grouped["Цель измерений"] || goalList[0] || "");
          setSelectedNormativeDoc(normativeList[0] || "");
          setSelectedDirection(grouped["Расположение направлений стоянок"] || directionsList[0] || "");
          setSelectedPointsHeight(grouped["Расположение точек съемки по высоте опоры"] || pointsHeightList[0] || "");
          setSelectedMeasurementTool(grouped["Средства измерений"] || measurementToolsList[0] || "");
          setSelectedConductedBy(grouped["Измерения проводил"] || measurementConductedByList[0] || "");
          setSelectedDevelopedBy(grouped["Разработал"] || developedByList[0] || "");

          setDateMeasurement(grouped["Дата проведения измерений"] || "");
          setDateProtocol(grouped["Дата протокола"] || "");

          if (activeProtocolId) {
            setIsLoading(true);
            axios.get(`/api/protocol-details/${activeProtocolId}/`, {
              headers: { Authorization: `Bearer ${token}` },
            })
              .then(response => {
                let data = response.data.data
                handleSelectOrAddToList(goalList, data[3].Value, setGoalMeasurementsOptions, setSelectedGoal);
                handleSelectOrAddToList(goalList, data[4].Value, setNormativeDocs, setSelectedNormativeDoc);
                handleSelectOrAddToList(directionsList, data[5].Value, setDirectionsOptions, setSelectedDirection);
                handleSelectOrAddToList(pointsHeightList, data[6].Value, setPointsHeightOptions, setSelectedPointsHeight);
                handleSelectOrAddToList(measurementToolsList, data[7].Value, setMeasurementToolsOptions, setSelectedMeasurementTool);
                handleSelectOrAddToList(measurementConductedByList, data[9].Value, setMeasurementConductedByOptions, setSelectedConductedBy);
                setDateMeasurement(formatDate(data[10].Value))
                setDateProtocol(formatDate(data[15].Value))
                handleSelectOrAddToList(developedByList, data[16].Value, setDevelopedByOptions, setSelectedDevelopedBy);
              })
              .catch(error => {
                console.error(`Ошибка загрузки деталей протокола ${activeProtocolId}:`, error);
              })
              .finally(() => {
                setIsLoading(false);
              });
          }

        })
        .catch((error) => {
          console.error("Ошибка загрузки данных протокола:", error);
        });
    }

  }, [ldoc, nvalue, token]);


  useEffect(() => {
    // Приоритет у activeProtocolId (режим редактирования), затем newProtocolId (новый протокол)
    setPhotoTabProtocolId(activeProtocolId || newProtocolId || null);
  }, [activeProtocolId, newProtocolId]);

  useEffect(() => {
    // Проверяем, что мы редактируем существующий протокол
    if (activeProtocolId) {
      setIsLoading(true); // Показываем индикатор загрузки
      // Запрашиваем данные изображения у API
      axios.get(`/api/sketch-image-content/${activeProtocolId}/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(response => {
          // console.log("Ответ API sketch-image:", response.data); // Для отладки
          // Проверяем, есть ли данные и содержит ли filename путь
          if (response.data && response.data.filename) {
            const networkPath = response.data.filename;
            // Преобразуем сетевой путь Windows UNC в file:// URL
            // \\server\path\file -> file://server/path/file
            if (networkPath.startsWith('\\\\')) {
              const fileUrl = 'file://' + networkPath.substring(2).replace(/\\/g, '/');
              console.log("Сформированный file:// URL:", fileUrl); // Для отладки
              setUploadedImage(fileUrl); // Устанавливаем URL в состояние
            } else {
              console.warn("Полученный путь не является UNC путем:", networkPath);
              setUploadedImage(null);
            }
          } else {
            // Если API вернул пустой ответ или нет filename
            console.log("Изображение для протокола не найдено (пустой ответ или нет filename).");
            setUploadedImage(null);
          }
        })
        .catch(error => {
          // Обработка ошибки запроса
          if (error.response) {
            // Сервер ответил кодом ошибки (например, 404)
            if (error.response.status === 404) {
              console.log("Изображение для протокола не найдено (API вернул 404).");
            } else {
              console.error("API вернул ошибку при загрузке изображения:", error.response.status, error.response.data);
            }
          } else if (error.request) {
            // Запрос был сделан, но ответ не получен
            console.error("Не удалось получить ответ от API sketch-image:", error.request);
          } else {
            // Что-то еще вызвало ошибку
            console.error("Ошибка при настройке запроса sketch-image:", error.message);
          }
          setUploadedImage(null); // Сбрасываем состояние в случае ошибки
        })
        .finally(() => {
          setIsLoading(false); // Скрываем индикатор загрузки
        });
    } else {
      // Если activeProtocolId null (создание нового), сбрасываем изображение
      setUploadedImage(null);
    }
  }, [activeProtocolId, token]); // Зависимости: срабатывает при изменении activeProtocolId или token

  useEffect(() => {
    if (newProtocolId) {
      loadStations(); // Загружаем станции при смене newProtocolId
    }
  }, [newProtocolId]);

  useEffect(() => {
    if (activeKey === 3 && newProtocolId) {
      loadStations();
    }
  }, [activeKey, newProtocolId]);

  const saveData = () => {
    const effectiveProtocolId = newProtocolId || activeProtocolId || 0;

    const parsedBaseWidth = parseFloat(baseWidthInput);
    const finalBaseWidth = isNaN(parsedBaseWidth) ? 0 : parsedBaseWidth;


    let finalAxisRotate = 0;
    switch (axisRotateInput) {
      case 'X':
        finalAxisRotate = 1;
        break;
      case 'Y':
        finalAxisRotate = 2;
        break;
      case 'XY':
        finalAxisRotate = 3;
        break;
      case 'Нет':
      default:
        finalAxisRotate = 0;
        break;
    }


    const payload = {
      Id: effectiveProtocolId,
      Name: "Протокол контроля вертикальности ствола опоры методом угловых измерений",
      ProtocolDate: dateProtocol ? new Date(dateProtocol).toISOString() : null,
      idMeasuring: getIdByName(selectedMeasurementTool, toolsList),
      idSpecObserver: getIdByName(selectedConductedBy, peopleList),
      idDoc: getIdByName(selectedNormativeDoc, normativeDocsList),
      idPhoto: null,
      ProtocolNum: groupedData["№ протокола"] || "",
      BaseWidth: finalBaseWidth,
      BeltDiameter: 0,
      SchemaNum: parseInt(selectedDirection) || 1,
      DateMeasuring: dateMeasurement ? new Date(dateMeasurement).toISOString() : null,
      idSpecExec: getIdByName(selectedDevelopedBy, peopleList),
      AxisRotate: finalAxisRotate,
      LocationDist: selectedPointsHeight.includes("внешние") ? "external" : "internal",
      LocationPoints: selectedPointsHeight,
      DiscrepBetween: (groupedData["Расхождения между приемами"] || "").replace(/"/g, ''),
      AvgError: (groupedData["Средняя квадратичная ошибка измерений"] || "").replace(/"/g, ''),
      NType: 1,
      Conclusion: "",
      RelRollerBelt: 0.8,
      IsAvgValueDevice: false,
      idProject: 456,
      idNormDocuments: getIdByName(selectedNormativeDoc, normativeDocsList)?.toString() || "",
      idMeasurings: getIdByName(selectedMeasurementTool, toolsList)?.toString() || "",
      Gost: groupedData["Нормативные документы"] || "",
      IsOutputHide: false,
      Note: "",
      TotalPages: 1,
      IsAllowPlanHeights: true,
      IsWorkNotTech: false,
      LDoc: ldoc
    };

    console.log('Payload для сохранения/обновления:', payload);

    axios.post('/api/protocol/save/', payload, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        console.log("Полный ответ от сервера:", response.data);

        if (!newProtocolId && response.data.protocol_id) {
          const createdProtocolId = response.data.protocol_id;
          console.log("Получен ID нового протокола:", createdProtocolId);
          setNewProtocolId(createdProtocolId);


          if (!photoTabProtocolId) {
            setPhotoTabProtocolId(createdProtocolId);
          }
        }

        alert(response.data.message || "Протокол успешно сохранен/обновлен");

        if (refreshProtocols) {
          refreshProtocols();
        }

        const finalProtocolId = newProtocolId || response?.data?.protocol_id;

        if (onSaveProtocol && typeof onSaveProtocol === 'function' && finalProtocolId) {
          onSaveProtocol({ Id: finalProtocolId });
        }

      })
      .catch((error) => {
        console.error("Ошибка сохранения/обновления:", error);
        if (error.response) {
          alert(`Ошибка сервера: ${error.response.data.message || error.response.data.error || 'Неизвестная ошибка'}`);
        } else {
          alert("Произошла ошибка при сохранении данных. Проверьте консоль для получения деталей.");
        }
      });
  };

  return (
    <CCard className="mb-4">
      <CCardBody>
        <CNav variant="tabs" role="tablist">
          <CNavItem>
            <CNavLink active={activeKey === 1} onClick={() => setActiveKey(1)}>
              Сведения о съемке
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink active={activeKey === 2} onClick={() => setActiveKey(2)}>
              Схема расположения станций
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink active={activeKey === 3} onClick={() => setActiveKey(3)}>
              Журналы угловых изменения станций
            </CNavLink>
          </CNavItem>
          {/* <CNavItem>
            <CNavLink active={activeKey === 4} onClick={() => setActiveKey(4)}>
              Анализ результатов
            </CNavLink>
          </CNavItem> */}
          <CNavItem>
            <CNavLink active={activeKey === 5} onClick={() => setActiveKey(5)}>
              Фото стоянок
            </CNavLink>
          </CNavItem>
        </CNav>

        <CTabContent>
          {/* Вкладка "Сведения о съемке" */}
          <CTabPane visible={activeKey === 1}>
            <SurveyInfoTab
              groupedData={groupedData}
              goalMeasurementsOptions={goalMeasurementsOptions}
              normativeDocs={normativeDocs}
              directionsOptions={directionsOptions}
              pointsHeightOptions={pointsHeightOptions}
              measurementToolsOptions={measurementToolsOptions}
              measurementConductedByOptions={measurementConductedByOptions}
              developedByOptions={developedByOptions}
              selectedGoal={selectedGoal}
              setSelectedGoal={setSelectedGoal}
              selectedNormativeDoc={selectedNormativeDoc}
              setSelectedNormativeDoc={setSelectedNormativeDoc}
              selectedDirection={selectedDirection}
              setSelectedDirection={setSelectedDirection}
              selectedPointsHeight={selectedPointsHeight}
              setSelectedPointsHeight={setSelectedPointsHeight}
              selectedMeasurementTool={selectedMeasurementTool}
              setSelectedMeasurementTool={setSelectedMeasurementTool}
              selectedConductedBy={selectedConductedBy}
              setSelectedConductedBy={setSelectedConductedBy}
              selectedDevelopedBy={selectedDevelopedBy}
              setSelectedDevelopedBy={setSelectedDevelopedBy}
              dateMeasurement={dateMeasurement}
              setDateMeasurement={setDateMeasurement}
              dateProtocol={dateProtocol}
              setDateProtocol={setDateProtocol}
            />
          </CTabPane>



          {/* Вкладка "Схема расположения станций" */}
          <CTabPane visible={activeKey === 2}>
            {/* Проверяем либо newProtocolId (для нового), либо activeProtocolId (для редактирования) */}
            {(newProtocolId || activeProtocolId) ? (
              <>
                {/* Блок с кнопками */}
                <div className="mb-3 d-flex gap-2 flex-wrap">
                  <CButton color="primary" onClick={() => document.getElementById('imageUploadInput')?.click()}>
                    Загрузить изображение
                  </CButton>
                  <CButton color="danger" onClick={() => setUploadedImage(null)}>
                    Удалить изображение
                  </CButton>
                  <CButton color="secondary">Фото из плана работ</CButton>
                  <CButton color="secondary">Загрузить карту</CButton>
                </div>
                {/* Скрытое поле для загрузки файла */}
                <input
                  id="imageUploadInput"
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      const reader = new FileReader();
                      reader.onload = (e) => {
                        setUploadedImage(e.target.result); // Для локально загруженных файлов будет Data URL
                      };
                      reader.readAsDataURL(file);
                    }
                  }}
                />
                {/* Отображение загруженного изображения */}
                <div style={{ marginTop: '20px' }}>
                  {isLoading ? ( // Показываем спиннер во время загрузки из API
                    <div className="text-center">
                      <CSpinner size="sm" />
                      <span className="ms-2">Загрузка изображения...</span>
                    </div>
                  ) : uploadedImage ? (
                    <img
                      src={uploadedImage} // src использует состояние uploadedImage (URL или Data URL)
                      alt="Загруженная схема"
                      style={{ maxWidth: '100%', maxHeight: '500px', border: '1px solid #ccc' }}
                      onError={(e) => { // Обработка ошибки загрузки изображения по URL
                        console.error("Ошибка загрузки изображения по URL:", e, "URL:", uploadedImage);
                      }}
                    />
                  ) : (
                    <p>Изображение не загружено</p>
                  )}
                </div>
              </>
            ) : (
              <div className="text-center text-danger">
                Для добавления схемы расположения станций необходимо сначала сохранить сведения о съемке.
              </div>
            )}
          </CTabPane>

          {/* Вкладка "Журналы угловых изменений станций" */}
          <CTabPane visible={activeKey === 3}>
            {newProtocolId ? (
              <>
                <div className="mb-3 d-flex align-items-center justify-content-between flex-wrap gap-2">
                  <div className="d-flex gap-2 flex-wrap">
                    <CButton color="secondary" onClick={openAddMeasurementModal}>Добавить</CButton>
                    <CButton
                      color="primary"
                      onClick={() => {
                        if (selectedStationId) {
                          alert("Функция изменения станции");
                        } else {
                          alert("Выберите станцию для изменения");
                        }
                      }}
                    >
                      Изменить
                    </CButton>
                    <CButton color="danger" onClick={handleDeleteStation}>
                      Удалить
                    </CButton>
                    <CButton
                      color="secondary"
                      disabled={selectedStationsForBinding.length !== 2}
                      onClick={() => setBindingPointsModalVisible(true)}
                    >
                      Назначить точку перевязки
                    </CButton>
                    <CButton color="secondary" onClick={handleUnbindPoint}>
                      Удалить точку перевязки
                    </CButton>
                  </div>

                  <div className="d-flex align-items-end gap-3 flex-wrap">
                    <div>

                      <label className="form-label mb-1">Ширина основания, м</label>
                      <CFormInput
                        type="number"
                        style={{ width: "150px" }}
                        value={baseWidthInput}
                        onChange={(e) => setBaseWidthInput(e.target.value)}
                      />
                    </div>
                    <div>
                      <label className="form-label mb-1">Развернуть ось</label>
                      <CFormSelect
                        style={{ width: "120px" }}
                        value={axisRotateInput} 
                        onChange={(e) => setAxisRotateInput(e.target.value)} 
                      >
                        <option value="Нет">Нет</option>
                        <option value="X">X</option>
                        <option value="Y">Y</option>
                        <option value="XY">XY</option>
                      </CFormSelect>
                    </div>
                  </div>
                </div>

                <CTable bordered hover responsive>
                  <CTableHead>
                    <CTableRow>
                      <CTableHeaderCell>№ станции</CTableHeaderCell>
                      <CTableHeaderCell>Расстояние от оси до стоянки</CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {stationsList.length > 0 ? (
                      stationsList.map((station) => {
                        const isSelected = selectedStationsForBinding.some(s => s.id === station.Id);
                        const isCurrent = selectedStationId === station.Id;
                        const bgColor = isSelected ? '#a8c9f7' : isCurrent ? '#66A7F2' : '';

                        return (
                          <CTableRow
                            key={station.Id}
                            onClick={() => {
                              setSelectedStationId(station.Id);

                              setSelectedStationsForBinding(prev => {
                                const exists = prev.find(s => s.id === station.Id);

                                if (exists) {
                                  return prev.filter(s => s.id !== station.Id);
                                } else if (prev.length < 2) {
                                  const newSelection = [...prev, { id: station.Id, number: station.StationNum }];

                                  if (newSelection.length === 2) {
                                    const [first, second] = newSelection.map(s => s.number);
                                    const validPairs = [
                                      [1, 3], [1, 4],
                                      [2, 3], [2, 4]
                                    ];
                                    const isValidPair = validPairs.some(pair =>
                                      (pair[0] === first && pair[1] === second) ||
                                      (pair[0] === second && pair[1] === first)
                                    );
                                    if (!isValidPair) return prev;
                                  }

                                  return newSelection;
                                }

                                return prev;
                              });
                            }}
                            style={{ cursor: 'pointer', backgroundColor: bgColor }}
                          >
                            <CTableDataCell style={{ backgroundColor: bgColor, fontWeight: isSelected ? 'bold' : 'normal' }}>
                              {station.StationNum}
                            </CTableDataCell>
                            <CTableDataCell style={{ backgroundColor: bgColor }}>
                              {station.DistanceDiag}
                            </CTableDataCell>
                          </CTableRow>
                        );
                      })
                    ) : (
                      <CTableRow>
                        <CTableDataCell colSpan="2" className="text-center">
                          Нет данных
                        </CTableDataCell>
                      </CTableRow>
                    )}
                  </CTableBody>
                </CTable>
              </>
            ) : (
              <div className="text-center text-danger">
                Для добавления журналов угловых изменений необходимо сначала сохранить сведения о съемке.
              </div>
            )}
          </CTabPane>


          {/* Вкладка "Анализ результатов" */}
          <CTabPane visible={activeKey === 4}>
            {newProtocolId ? (
              <>
                {/* Блок с кнопками */}
                <div className="mb-3 d-flex gap-2">
                  <CButton color="secondary" onClick={() => setAddResultModalVisible(true)}>
                    Добавить
                  </CButton>
                  <CButton color="secondary">Изменить</CButton>
                  <CButton color="secondary">Удалить</CButton>
                </div>

                {/* Таблица */}
                <CTable bordered>
                  <CTableHead>
                    <CTableRow>
                      <CTableHeaderCell>Дата проведения измерений</CTableHeaderCell>
                      <CTableHeaderCell>Крен объекта, мм</CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {/* Таблица с анализом */}
                  </CTableBody>
                </CTable>
              </>
            ) : (
              <div className="text-center text-danger">
                Для добавления анализа крена необходимо сначала сохранить сведения о съемке.
              </div>
            )}
          </CTabPane>
          {/* Вкладка "Фото стоянок" */}
          <CTabPane visible={activeKey === 5}>
            {/* Используем photoTabProtocolId, управляемый эффектом выше */}
            {photoTabProtocolId ? (
              <PhotoTab
                idProtocol={photoTabProtocolId} // <-- Передаем обновляемый ID
              />
            ) : (
              <div className="text-center text-danger">
                Для добавления фото необходимо сначала сохранить сведения о съемке.
              </div>
            )}
          </CTabPane>
        </CTabContent>
        <div className="d-flex justify-content-end gap-3 mt-auto pt-4">
          <CButton color="secondary" onClick={() => {/* Логика отмены */ }}>
            Отменить
          </CButton>
          <CButton color="success" onClick={saveData}>
            Сохранить
          </CButton>
        </div>

        <PhotoParkingModal
          visible={isModalVisible}
          onClose={() => setModalVisible(false)}
          name={modalName}
          setName={setModalName}
          filePath={modalFilePath}
          setFilePath={setModalFilePath}
        />
        <AddResultModal
          visible={addResultModalVisible}
          onClose={() => setAddResultModalVisible(false)}
          onSave={(data) => {
            console.log('Данные сохранены:', data);
            // Здесь можно отправить данные на сервер или обновить таблицу
            setAddResultModalVisible(false);
          }}
        />
        <AddMeasurementModal
          visible={addMeasurementModalVisible}
          onClose={() => {
            setAddMeasurementModalVisible(false);
            loadStations(); // <-- Загружаем станции после закрытия модалки
          }}
          protocolId={newProtocolId} // Передаем ID протокола в модалку
        />

        <BindingPointsModal
          visible={bindingPointsModalVisible}
          onClose={() => setBindingPointsModalVisible(false)}
          stationOne={selectedStationsForBinding[0]}
          stationTwo={selectedStationsForBinding[1]}
          onSave={(data) => {
            console.log('Данные перевязки:', data);
          }}
          onBindingSaved={loadStations}

        />
      </CCardBody>
    </CCard>
  );
};

export default ProtocolVerticality;